import { render, staticRenderFns } from "./article-add.vue?vue&type=template&id=424d25ee&scoped=true&"
import script from "./article-add.vue?vue&type=script&lang=js&"
export * from "./article-add.vue?vue&type=script&lang=js&"
import style0 from "./article-add.vue?vue&type=style&index=0&id=424d25ee&lang=less&scoped=true&"
import style1 from "@/assets/less/i-switch.less?vue&type=style&index=1&id=424d25ee&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "424d25ee",
  null
  
)

component.options.__file = "article-add.vue"
export default component.exports